module.exports = require("core-js/library/fn/object/define-property");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/define-property.js
// module id = 560
// module chunks = 0